import type { Entity } from "@common/types/entity";
import { EntityAvatarGroup } from "@components/avatar/EntityAvatarGroup";
import styles from "./TaskEntityAvatars.module.scss";

/** A task's entities as up to three avatars, each named after its entity. */
export const TaskEntityAvatars = ({
    entities,
}: {
    entities: readonly Entity[];
}) =>
    entities.length > 0 ? (
        <span className={styles.entityAvatars}>
            <EntityAvatarGroup entities={entities} max={3} size="xs" />
        </span>
    ) : null;
